export default {"src":"/_next/static/media/sign.093e9acb.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};